export enum ESize {
    S = 'S', // Small
    M = 'M', // Middle
    L = 'L', // Large
}
